import ScrollReveal from 'scrollreveal';
import Sticky from 'sticky-kit/dist/sticky-kit';

const $stickyRail = $('.js-narrative-sticky');
const mqLG = matchMedia('(min-width: 960px)');

const $nav = $('.js-narrative__nav');
const $button = $('.js-chapter-link');
const $top = $('.js-back-to-top');

let navHidden = true;
let autoScroll = false;
let $chapters = $(".narrative__chapter");

function narrative() {

  // Listen for changes to the media query
  if ('matchMedia' in window) {
    mqLG.addListener(stickChapterNumbers.bind(this));
  }
  stickChapterNumbers();

  initNav();

  initScrollReveal();
}

//--------------------------------------
// Sticky Sidebar
//--------------------------------------

function stickChapterNumbers(){
  // Stick left rail when screen width is > lg breakpoint (960px)
  if (mqLG && mqLG.matches) {
    $stickyRail.stick_in_parent();
  } else {
    $stickyRail.trigger('sticky_kit:detach');
  }
}

//--------------------------------------
// Scroll Reveal
//--------------------------------------

function initScrollReveal(){
  var options = {
    reset: false,
    mobile: false,
    distance: 0,
    duration: 250,
    scale: 1,
    delay: 0,
    viewFactor: 0.5,
    easing: 'ease-in-out',
  }
  window.sr = ScrollReveal(options);
  sr.reveal('.js-reveal');
}

//--------------------------------------
// Navigation
//--------------------------------------

function initNav(){
  $(window).bind( "scroll", throttle(checkScrollPosition, 100) );

  checkScrollPosition();

  updateNavProgress();

  setScrollFromHash();

  $button.on('click', handleNavClick);

  $top.on('click', scrollToTop);

  window.onhashchange = setScrollFromHash;
}

//--------------------------------------
// Hide/Show Navigation
//--------------------------------------

function displayNav(){
  navHidden = false;
  $nav.addClass('narrative__nav--visible');
}

function hideNav(){
  navHidden = true;
  $nav.removeClass('narrative__nav--visible');
}

function checkScrollPosition(){
  let currentScrollPosition = $(window).scrollTop();
  if (currentScrollPosition > 600 && navHidden === true){
    displayNav();
  } else if (currentScrollPosition <= 600 && navHidden === false) {
    hideNav();
  }
}

//--------------------------------------
// Scroll Jump from Hash
//--------------------------------------

function setScrollFromHash(){
  if (window.location.hash.length){
    scrollToHash(window.location.hash);
  }
}

function handleNavClick(e){
  e.preventDefault();
  const hash = e.currentTarget.hash;
  window.location.hash = hash;
  scrollToHash(hash);
}

function scrollToHash(hash){
  const selector = `.${hash.substring(1)}`;
  autoScroll = true;
  $('html, body').animate({
    scrollTop: $(selector).offset().top
  }, 800, function() {
    autoScroll = false;
    updateNavProgress();
  });
}

function scrollToTop(){
  autoScroll = true;
  $('html, body').animate({
    scrollTop: 0
  }, 800, function() {
    autoScroll = false;
    updateNavProgress();
  });
}

//--------------------------------------
// Scroll Throttle
//--------------------------------------

function throttle (callback, limit){
  let wait = false;
  return function () {
    if (!wait) {
      scrollTick.call();
      wait = true;
      setTimeout(function () {
          wait = false;
      }, limit);
    }
  }
}

function scrollTick(){
  checkScrollPosition();
  updateNavProgress();
}

//--------------------------------------
// Update the current nav item
//--------------------------------------

function updateNavProgress(){
  let docViewTop = $(window).scrollTop();
  let docViewBottom = docViewTop + $(window).height();

  if(autoScroll === false){
    $chapters.each(function(i){
      let elemTop = $(this).offset().top;
      let elemBottom = elemTop + $(this).height();
      let $currentChapter = $(".narrative__nav-chapter:eq("+i+")");

      if (elemTop <= docViewBottom && elemBottom >= docViewBottom) {
        $currentChapter.focus();
        $currentChapter.addClass('narrative__nav-chapter--current');
      } else {
        $currentChapter.removeClass('narrative__nav-chapter--current');
      }
    });
  }
}

export default narrative;
